import { useAsyncResults } from 'hooks/context/useAsyncResults';
import AsyncResultReport from './AsyncResultReport/AsyncResultReport';
import styles from './styles.module.scss';

const AsyncResults = () => {
  const { reportResults } = useAsyncResults();

  // Håndtering av asynkrone kall. Komponentene under viser status og lasting i bokser nederst i høyre hjørnet.
  // For å se hvordan man legger håndterer / legger til nye kall, se "useAsyncResults" i hooks-mappen.

  // Grunnet ulik håndtering av http-koder o.l, så ligger det to nesten identiske komponenter under.
  return (
    <div className={styles.asyncResults}>
      {reportResults.map((data) => (
        <AsyncResultReport data={data} key={data.id} />
      ))}
    </div>
  );
};

export default AsyncResults;
